module.exports = __webpack_public_path__ + "static/quote_2-eecbeb102ff5397b874f5368bba53c10.png";